// extracted by mini-css-extract-plugin
export var center = "webReports-module--center--TOKln";
export var icon = "webReports-module--icon--cZdVl";